import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  serviceLabel: {
    defaultMessage: 'Service',
    id: '66yw5j',
    description: 'Rate Shopper picked service label',
  },
});
